/* eslint-disable camelcase */
import da_dk from './i18n/da-dk.json';
import de_at from './i18n/de-at.json';
import de_ch from './i18n/de-ch.json';
import de_de from './i18n/de-de.json';
import en_au from './i18n/en-au.json';
import en_ca from './i18n/en-ca.json';
import en_gb from './i18n/en-gb.json';
import en_ie from './i18n/en-ie.json';
import en_in from './i18n/en-in.json';
import en_nz from './i18n/en-nz.json';
import en_us from './i18n/en-us.json';
import es_es from './i18n/es-es.json';
import es_us from './i18n/es-us.json';
import fi_fi from './i18n/fi-fi.json';
import fr_be from './i18n/fr-be.json';
import fr_ca from './i18n/fr-ca.json';
import fr_ch from './i18n/fr-ch.json';
import fr_fr from './i18n/fr-fr.json';
import it_ch from './i18n/it-ch.json';
import it_it from './i18n/it-it.json';
import nb_no from './i18n/nb-no.json';
import nl_be from './i18n/nl-be.json';
import nl_nl from './i18n/nl-nl.json';
import pt_pt from './i18n/pt-pt.json';
import sv_se from './i18n/sv-se.json';
export const DEFAULT_LOCALE = 'en-us';
// @ts-expect-error
const mapping = {
    'da-dk': da_dk,
    'de-at': de_at,
    'de-ch': de_ch,
    'de-de': de_de,
    'en-au': en_au,
    'en-ca': en_ca,
    'en-gb': en_gb,
    'en-ie': en_ie,
    'en-in': en_in,
    'en-nz': en_nz,
    'en-us': en_us,
    'es-es': es_es,
    'es-us': es_us,
    'fi-fi': fi_fi,
    'fr-be': fr_be,
    'fr-ca': fr_ca,
    'fr-ch': fr_ch,
    'fr-fr': fr_fr,
    'it-it': it_it,
    'it-ch': it_ch,
    'nb-no': nb_no,
    'nl-be': nl_be,
    'nl-nl': nl_nl,
    'pt-pt': pt_pt,
    'sv-se': sv_se,
};
mapping.default = mapping[DEFAULT_LOCALE];
export function getTranslationMap(locale) {
    return Object.assign(Object.assign({}, mapping.default), mapping[locale]);
}
//# sourceMappingURL=i18n.js.map